import { render, staticRenderFns } from "./Material.vue?vue&type=template&id=3f7dafc1&scoped=true"
import script from "./Material.vue?vue&type=script&lang=js"
export * from "./Material.vue?vue&type=script&lang=js"
import style0 from "./Material.vue?vue&type=style&index=0&id=3f7dafc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7dafc1",
  null
  
)

export default component.exports